
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import { GetAllStates, GetAllTenants, GetDistricts, getAllArea, saveCollegeAdmin, saveCreateUser, updateCollegeAdmin, updateCreateUser } from '../../../../services/CommonService';

function AddCollegeAdmin({ updateprop }) {
    const [filefields, setFileFields] = useState(null);
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const fields = {
        position: '',
        name: '',
        email: '',
        password: '',
        tenantid: '',
        subapplicationid: '',
        role: '',
        mobileno: "",
        stateid: '',
        districtid: ''



    }

    const errors = {
        position: '',
        name: '',
        email: '',
        password: '',
        tenantid: '',
        subapplicationid: '',
        role: '',
        mobileno: '',

    }

    const [errorFields, setErrorFields] = useState(errors);
    const [formfields, setFromFields] = useState(fields);
    const [tenant, setTenant] = useState([]);
    const [area, setArea] = useState([])
    const [val, setval] = useState('')
    const [states, setStates] = useState([])
    const [district, setDistricts] = useState([])



    useEffect(() => {
        getTenant()
        setFieldData();

    }, []);

    const { name, email, password, position, tenantid, subapplicationid, role, mobileno, stateid, districtid } = formfields;

    const setFieldData = async () => {
        console.log("updateprop", updateprop);
        if (updateprop?.id) {
            setFromFields(updateprop);
            setval(updateprop.tenantid)

        }
    }

    const getTenant = async () => {
        const reqparams = {
            pageno: "-1",
            query: { status: "Active" }
        }
        const ResponseData = await GetAllTenants(reqparams)
        setTenant(ResponseData.data)
    }
    const getStates = async (val) => {
        const reqparams = {
            pageno: "-1",
            query: {
                status: "Active",
                tenant: { $elemMatch: { "value": val } }
            }

        }
        const ResponseData = await GetAllStates(reqparams)
        setStates(ResponseData?.data)
    }

     const getDistricts = async (val) => {
        const reqparams = {
            pageno: "-1",
            query: {
                status: "Active",
               stateid:val
            }

        }
        const ResponseData = await GetDistricts(reqparams)
        setDistricts(ResponseData?.data)
    }

    const getColleges = async (val) => {
        const reqparams = {
            pageno: "-1",
            query: { status: "Active", tenantid: val }
        }
        const ResponseData = await getAllArea(reqparams)
        setArea(ResponseData.data)
    }

    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;

        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Please enter name .";
        }
        if (!fields["position"]) {
            formIsValid = false;
            errors["position"] = "*Please enter position .";
        }
        if (!fields["email"]) {
            formIsValid = false;
            errors["email"] = "*Please enter email .";
        }
        if (!fields["password"]) {
            formIsValid = false;
            errors["password"] = "*Please enter password .";
        }
        if (!fields["tenantid"]) {
            formIsValid = false;
            errors["tenantid"] = "*Please select tenant.";
        }

        if (!fields["role"]) {
            formIsValid = false;
            errors["role"] = "*Please select role .";
        }
        if (!fields["mobileno"]) {
            formIsValid = false;
            errors["mobileno"] = "*Please enter mobileno .";
        }


        setErrorFields(errors)
        return formIsValid;

    }

    const submitForm = async () => {
        console.log(formfields);
        const isValid = await validateForm();
        if (isValid) {

            if (!formfields.id) {
                //save
                const Response = await saveCollegeAdmin(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("user saved successfully");
                    formfields.id = Response.data.id;
                }

            } else {
                //update
                const Response = await updateCollegeAdmin(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("user updated successfully");
                    formfields.id = Response.data.id;
                }
            }

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

        if (name == "tenantid") {
            // console.log("value",value);
            setval(value)
            getColleges(value)
            getStates(value)
        }

        if(name =="stateid"){
            getDistricts(value)
            
        }

    }
    return (
        <>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Position
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Display Order"
                        name="position"
                        className="form-control"

                        value={position} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.position}</div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Name
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Name"
                        name="name"
                        className="form-control"

                        value={name} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.name}</div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Email
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Email"
                        name="email"
                        className="form-control"

                        value={email} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.email}</div>
            </div>


            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Mobileno
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Mobile number"
                        name="mobileno"
                        className="form-control"

                        value={mobileno} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.mobileno}</div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Password
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Password"
                        name="password"
                        className="form-control"

                        value={password} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.password}</div>
            </div>
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Role
                </label>
                <div className="col-lg-6">
                    <select
                        className="form-control" name='role'
                        onChange={handleChange} value={role}>
                        <option value="">Select Role</option>
                        <option value="COLLEGE_ADMIN">COLLEGE_ADMIN</option>
                        <option value="SUPPORT_TEAM">SUPPORT_TEAM</option>
                        <option value="GUEST_USER">GUEST_USER</option>
                        <option value="POLITICAL">POLITICAL</option>
                        <option value="DEMO_USER">DEMO_USER</option>

                    </select>

                </div>
                <div className="errorMsg">{errorFields.role}</div>
            </div>



            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Tenant
                </label>
                <div className="col-lg-6">
                    <select className="form-control" name="tenantid"
                        value={tenantid} onChange={handleChange}>
                        <option value=''>Select Tenant</option>
                        {tenant?.map(item => (
                            <option
                                key={item.id}
                                value={item.tenantid}
                            >
                                {item.name}
                            </option>
                        ))}
                    </select>

                </div>
                <div className="errorMsg">{errorFields.tenantid}</div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    State
                </label>
                <div className="col-lg-6">
                    <select className="form-control" name="stateid"
                        value={stateid} onChange={handleChange}>
                        <option value=''>Select State</option>
                        {states?.map(item => (
                            <option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </option>
                        ))}
                    </select>

                </div>
            </div>
              <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    District
                </label>
                <div className="col-lg-6">
                    <select className="form-control" name="districtid"
                        value={districtid} onChange={handleChange}>
                        <option value=''>Select District</option>
                        {district?.map(item => (
                            <option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </option>
                        ))}
                    </select>

                </div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    College
                </label>
                <div className="col-lg-6">
                    <select className="form-control" name="subapplicationid"
                        value={subapplicationid} onChange={handleChange}>
                        <option value=''>Select College</option>
                        {area?.map(item => (
                            <option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </option>
                        ))}
                    </select>

                </div>
            </div>
            <br />
            <div className="form-group">
                <button onClick={submitForm} className="btn btn-primary" type="button"
                >Save</button>
            </div>

        </>
    )
}

export default AddCollegeAdmin